import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import ReactPaginate from 'react-paginate'
import { Modal } from 'react-bootstrap'

import { ConfirmDialog } from '../../../common/confirm_dialog'

import { getListItemsCountMessage } from '../../../common/helpers'
import { LoadingOverlay } from '../../../common/loading_overlay'

import { getDriverTimesheetsData, getDriverTimesheetsFetching } from '../selectors'
import * as driversActionCreators from '../actionCreators'

import { deleteDriverTimesheet } from '../../driver_timesheets/actionCreators'
import { getDriverTimesheetDeleting } from '../../driver_timesheets/selectors'

import DriversTimesheetsListRow from './DriversTimesheetsListRow'
import DriverTimesheetsEditForm from '../../driver_timesheets/components/DriverTimesheetsEditForm'
import PermissionsCheck from '../../auth/components/PermissionsCheck'
import { PERMS_TIMESHEETS } from '../permissions'

class DriversTimesheetsList extends Component {
    state = {
        confirmDialog: {
            show: false,
            title: '',
            message: '',
            labelCancel: '',
            labelAccept: '',
            classNameAccept: 'text-success',
            classNameCancel: 'text-default',
            onCancel: () => {},
            onAccept: () => {},
        },
        modalTimesheet: {
            show: false,
            item: null,
        },
    }

    // confirm dialog
    showConfirmDialog = options => {
        this.setState({
            confirmDialog: {
                show: true,
                title: options.title || this.props.intl.formatMessage({ id: 'confirmDialog.default.title' }),
                message: options.message || this.props.intl.formatMessage({ id: 'confirmDialog.default.message' }),
                labelCancel: options.labelCancel || this.props.intl.formatMessage({ id: 'confirmDialog.default.cancel' }),
                labelAccept: options.labelAccept || this.props.intl.formatMessage({ id: 'confirmDialog.default.accept' }),
                classNameAccept: options.classNameAccept || 'btn-success',
                classNameCancel: options.classNameCancel || 'btn-default',
                onCancel: options.onCancel || this.hideConfirmDialog,
                onAccept: options.onAccept || this.hideConfirmDialog,
            },
        })
    }

    hideConfirmDialog = () => {
        this.setState({
            confirmDialog: {
                show: false,
                onCancel: () => {},
                onAccept: () => {},
            },
        })
    }

    // handles
    onClick = item => {
        this.setState({
            modalTimesheet: {
                show: true,
                item,
            },
        })
    }

    onDelete = item => {
        this.showConfirmDialog({
            title: this.props.intl.formatMessage({ id: 'confirmDialog.delete.title' }),
            message: this.props.intl.formatMessage({ id: 'confirmDialog.delete.message' }),
            labelCancel: this.props.intl.formatMessage({ id: 'confirmDialog.delete.cancel' }),
            labelAccept: this.props.intl.formatMessage({ id: 'confirmDialog.delete.accept' }),
            classNameAccept: 'btn-danger',
            onAccept: () => {
                this.props.actions.deleteDriverTimesheet(item.id)
                this.hideConfirmDialog()
            },
        })
    }

    onPageChange = page => {
        this.props.actions.fetchDriverTimesheets(this.props.driver.id, page.selected)
    }

    handleExport = e => {
        e && e.preventDefault()
        this.props.actions.exportDriverTimesheets(this.props.driver.id)
    }

    handleCreateItem = e => {
        e && e.preventDefault()
        this.setState({
            modalTimesheet: {
                show: true,
                item: null,
            },
        })
    }

    // create modal
    modalTimesheetClose = () => {
        this.setState({
            modalTimesheet: {
                show: false,
                item: null,
            },
        })
    }

    // callbacks
    editSuccessCallback = () => {
        this.modalTimesheetClose()
        this.refresh()
    }

    editBackCallback = () => {
        this.modalTimesheetClose()
    }

    refresh = () => {
        this.props.actions.fetchDriverTimesheets(this.props.driver.id)
    }

    componentDidMount() {
        if (this.props.driver) {
            this.props.actions.fetchDriverTimesheets(this.props.driver.id)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.driver && JSON.stringify(nextProps.driver) !== JSON.stringify(this.props.driver)) {
            this.props.actions.fetchDriverTimesheets(nextProps.driver.id)
        }

        if (this.props.deleting && !nextProps.deleting) {
            this.refresh()
        }
    }

    render() {
        const data = this.props.data

        const rows = data && data.data
        const page = data && data.page ? data.page : 0
        const total = data && data.total ? data.total : 0

        return (
            <PermissionsCheck hasAny={Object.values(PERMS_TIMESHEETS)} noPermissionsTab>
                <LoadingOverlay active={this.props.fetching || this.props.deleting}>
                    <div className="btns-list">
                        <button className="btn btn-default btn-addon m-r-xs" onClick={this.refresh}>
                            <i className="far fa-sync-alt" /> <FormattedMessage id="buttons.refresh" />
                        </button>
                        {rows && rows.length > 0 && (
                            <PermissionsCheck has={[PERMS_TIMESHEETS.EXPORT]}>
                                <button className="btn btn-primary btn-addon m-r-xs" onClick={this.handleExport}>
                                    <i className="far fa-file-excel" /> <FormattedMessage id="buttons.exportToXLS" />
                                </button>
                            </PermissionsCheck>
                        )}
                        <PermissionsCheck has={[PERMS_TIMESHEETS.CREATE]}>
                            <button className="btn btn-addon btn-success" onClick={this.handleCreateItem}>
                                <i className="far fa-plus" /> <FormattedMessage id="buttons.createItem" />
                            </button>
                        </PermissionsCheck>
                    </div>

                    {rows && rows.length > 0 ? (
                        <React.Fragment>
                            <div className="table-container">
                                <table className="table table-striped table-hover table-fixed-header">
                                    <thead>
                                        <tr>
                                            <PermissionsCheck hasAny={[PERMS_TIMESHEETS.UPDATE, PERMS_TIMESHEETS.DELETE]}>
                                                <th className="w-60" />
                                            </PermissionsCheck>
                                            <th className="w-120">
                                                <FormattedMessage id="fields.activity" />
                                            </th>
                                            <th className="w-120">
                                                <FormattedMessage id="fields.from" />
                                            </th>
                                            <th className="w-120">
                                                <FormattedMessage id="fields.to" />
                                            </th>
                                            <th className="w-120 text-right">
                                                <FormattedMessage id="fields.time" />
                                            </th>
                                            <th className="w-max wm-120">
                                                <FormattedMessage id="fields.note" />
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows &&
                                            rows.map((item, index) => (
                                                <DriversTimesheetsListRow
                                                    // eslint-disable-next-line react/no-array-index-key
                                                    key={`row-${index}`}
                                                    item={item}
                                                    onClick={this.onClick}
                                                    onDelete={this.onDelete}
                                                />
                                            ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="pull-left m-l-xxs m-t-md">
                                <FormattedMessage id="pagination.totalRecords" />: {getListItemsCountMessage(0, 0, total)}
                            </div>

                            <ReactPaginate
                                containerClassName="pagination"
                                breakLabel={<span className="disabled">...</span>}
                                activeClassName="active"
                                pageCount={Math.ceil(total / 50)}
                                pageRangeDisplayed={10}
                                marginPagesDisplayed={2}
                                forcePage={page}
                                onPageChange={this.onPageChange}
                                previousLabel={this.props.intl.formatMessage({ id: 'pagination.previous' })}
                                nextLabel={this.props.intl.formatMessage({ id: 'pagination.next' })}
                            />
                        </React.Fragment>
                    ) : (
                        <div className="alert alert-danger pull-left wp-100">
                            <FormattedMessage id="fields.noItemsFound" />
                        </div>
                    )}
                </LoadingOverlay>

                <Modal show={Boolean(this.state.modalTimesheet.show)} onHide={this.modalTimesheetClose} bsSize="sm">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {this.state.modalTimesheet.item ? <FormattedMessage id="fields.itemEdit" /> : <FormattedMessage id="fields.itemCreate" />}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <DriverTimesheetsEditForm
                            driverTimesheetID={this.state.modalTimesheet.item && this.state.modalTimesheet.item.id}
                            successCallback={this.editSuccessCallback}
                            backCallback={this.editBackCallback}
                            defaultValues={{
                                driver_id: this.props.driver.id,
                            }}
                            hiddenFields={['driver_id']}
                            PERMS={PERMS_TIMESHEETS}
                        />
                    </Modal.Body>
                </Modal>

                <ConfirmDialog options={this.state.confirmDialog} />
            </PermissionsCheck>
        )
    }
}

function mapStateToProps(state) {
    return {
        data: getDriverTimesheetsData(state),
        fetching: getDriverTimesheetsFetching(state),
        deleting: getDriverTimesheetDeleting(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            ...bindActionCreators(
                {
                    ...driversActionCreators,
                    deleteDriverTimesheet,
                },
                dispatch
            ),
        },
        dispatch,
    }
}

function mergeProps(stateProps, dispatchProps, ownProps) {
    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
    }
}

export default injectIntl(
    connect(
        mapStateToProps,
        mapDispatchToProps,
        mergeProps
    )(DriversTimesheetsList)
)
